export default __webpack_public_path__ + "static/media/projects-6.82d390e0.jpg";